"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToChar = exports.numberToRoman = exports.numberWithMinDigits = exports.transformNumberToStyle = exports.getSizeFromSvg = exports.convertToPixel = exports.round = exports.roundToEven = exports.convertToNumber = exports.INCHES_TO_CM = exports.DPI = void 0;
exports.DPI = 96;
exports.INCHES_TO_CM = 2.54;
function convertToNumber(value) {
    const num = Number(value);
    return Number.isNaN(num) ? undefined : num;
}
exports.convertToNumber = convertToNumber;
/**
 * Round to the nearest even integer
 */
function roundToEven(value) {
    return 2 * Math.round(value / 2);
}
exports.roundToEven = roundToEven;
function round(value, decimalPlaces = 2) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
}
exports.round = round;
function convertToPixel(value, unit, dpi, roundEven = false) {
    const roundFunction = roundEven ? roundToEven : round;
    switch (unit) {
        case 'cm':
            return roundFunction((value * (dpi !== null && dpi !== void 0 ? dpi : exports.DPI)) / exports.INCHES_TO_CM);
        case 'mm':
            return roundFunction((value * (dpi !== null && dpi !== void 0 ? dpi : exports.DPI)) / (exports.INCHES_TO_CM * 10));
        case 'in':
            return roundFunction(value * (dpi !== null && dpi !== void 0 ? dpi : exports.DPI));
        default:
            return roundFunction(value);
    }
}
exports.convertToPixel = convertToPixel;
function getSizeFromSvg(document) {
    const svgElement = document.querySelector('svg');
    const width = Number(svgElement.getAttribute('width'));
    const height = Number(svgElement.getAttribute('height'));
    return { width, height };
}
exports.getSizeFromSvg = getSizeFromSvg;
function transformNumberToStyle(value, style) {
    switch (style) {
        case 'numbers':
            return Number(value).toString();
        case 'numbers-with-two-digits':
            return numberWithMinDigits(value, 2).toString();
        case 'numbers-with-three-digits':
            return numberWithMinDigits(value, 3).toString();
        case 'numbers-with-four-digits':
            return numberWithMinDigits(value, 4).toString();
        case 'letters':
            return numberToChar(value, false);
        case 'capital-letters':
            return numberToChar(value, true);
        case 'roman-numbers':
            return numberToRoman(value);
        case 'roman-numbers-lower':
            return numberToRoman(value).toLowerCase();
        default:
            return String(value);
    }
}
exports.transformNumberToStyle = transformNumberToStyle;
function numberWithMinDigits(value, minDigits) {
    return new Intl.NumberFormat('en', {
        minimumIntegerDigits: minDigits,
        maximumFractionDigits: 0,
        useGrouping: false,
    }).format(value);
}
exports.numberWithMinDigits = numberWithMinDigits;
function numberToRoman(value) {
    var _a;
    const digits = String(+value).split('');
    const key = [
        '',
        'C',
        'CC',
        'CCC',
        'CD',
        'D',
        'DC',
        'DCC',
        'DCCC',
        'CM',
        '',
        'X',
        'XX',
        'XXX',
        'XL',
        'L',
        'LX',
        'LXX',
        'LXXX',
        'XC',
        '',
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
    ];
    let roman = '';
    let i = 3;
    while (i--) {
        roman = (key[+((_a = digits.pop()) !== null && _a !== void 0 ? _a : 0) + i * 10] || '') + roman;
    }
    return Array(+digits.join('') + 1).join('M') + roman;
}
exports.numberToRoman = numberToRoman;
function numberToChar(value, uppercase = false, startingAt = 1) {
    var _a;
    let baseNumber = value - startingAt;
    const reference = 'abcdefghijklmnopqrstuvwxyz';
    const alphabet = uppercase ? reference.toUpperCase() : reference;
    const base = alphabet.length;
    const digits = [];
    const chars = [];
    do {
        const digit = baseNumber % base;
        digits.push(digit);
        baseNumber = Math.floor(baseNumber / base);
    } while (baseNumber-- > 0);
    while (digits.length) {
        chars.push(alphabet[(_a = digits.pop()) !== null && _a !== void 0 ? _a : 0]);
    }
    return chars.join('');
}
exports.numberToChar = numberToChar;
//# sourceMappingURL=number-utils.js.map